module.exports = __webpack_public_path__ + "static/media/13.ea4b2d7a.jpg";